<template>
  <div class="flex-initial">
    <div class="relative h-14">
      <ChannelLabel v-if="channel" :channel="channel" asTooltip="true" customer="true" />
      <Avatar v-bind:customer="customer.attributes" class="hidden sm:block" size="h-10 w-10" />
    </div>
  </div>
  <div class="flex-grow pl-2">
    <div class="bg-white rounded-2xl p-2 pl-3 pr-3 text-left relative inline-block shadow relative" :class="{'opacity-40': message.status === 'deleted'}" :style="customWidthStyle">
      <span v-if="message.media_type === 'button'" class="block tracking-widest text-xs uppercase mb-3 text-gray-600 absolute automation-message-label">
        {{ $t('conversation.templatedMessageReply')}}
      </span>
      <div v-if="message.status === 'deleted'">
        [{{ $t('conversation.messageDeleted') }}]
        <span class="text-xs text-gray-600" :class="{'block text-right': textIsLong, 'inline-block align-bottom':!textIsLong}">
          <span v-if="hideStatus">
            {{ $t('conversation.justNow') }}
          </span>
          <span v-else>
            <Datetime v-bind:date="message.created_at" fromNow="true" />
          </span>
        </span>
      </div>
      <div v-else>
        <FileAttachments v-on:image-width="handleImageWidthLimit" :message="message" />
        <div v-if="message.media_type === 'audio'">
           <audio controls>
              <source v-bind:src="message.media_uri">
            </audio>
        </div>
        <div v-if="message.media_type === 'location'">
           <GoogleMap :api-key="googleMapsKey" style="width: 100%; height: 400px" :center="sharedPosition" :zoom="15">
             <GMarker :options=markerOptions />
           </GoogleMap>
        </div>
        <p class="whitespace-pre-line break-words max-w-screen-sm">
          <span v-if="message.media_type === 'button'" class="block w-72">
            <span  v-tippy>
              <span v-if="message.media_uri" class="block">{{ message.media_uri }}</span>
              <span v-else>{{ $t('conversation.buttonClicked')}}</span>
            </span>
            <tippy>{{ $t('conversation.buttonClicked')}}</tippy>
          </span>
          <span class="mr-2" :class="{'block': textIsLong, 'inline-block pb-1': !textIsLong}">
            <span v-if="message.media_type === 'location'" class="block mt-2" style="width: 600px">
              <span v-if="message.text" v-linkify:options="{target: '_blank'}">
                {{message.text}}
              </span>
              <span v-else>
                <em>{{ $t('conversation.noAddressGiven') }}</em>
              </span>
            </span>
            <span v-else  v-linkify:options="{target: '_blank'}">
              {{message.text}}
            </span>
          </span>
          <span class="text-xs text-gray-600" :class="{'block text-right': textIsLong, 'inline-block align-bottom':!textIsLong}">
            <span v-if="hideStatus">
              {{ $t('conversation.justNow') }}
            </span>
            <span v-else>
              <Datetime v-bind:date="message.created_at" fromNow="true" />
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>



<script>
import Datetime from '../../building_blocks/DateTime.vue'
import ChannelLabel from '../parts/ChannelLabel.vue'
import FileAttachments from '../parts/FileAttachments.vue'
import Avatar from '../parts/AvatarWidget.vue'
import { GoogleMap, Marker as GMarker } from "vue3-google-map";

export default {
  name: 'CustomerMessage',
  props: ['message', 'channel', 'customWidthStyle', 'hideStatus', 'textIsLong', 'customer'],
  emits: ['image-width'],
  setup() {
  },
  components: {
    Datetime,
    ChannelLabel,
    FileAttachments,
    Avatar,
    //
    GoogleMap,
    GMarker,
  },
  methods: {
     handleImageWidthLimit(width) {
       this.$emit('image-width', width);
     },
  },
  computed: {
    markerOptions() {
      return {
        position: this.sharedPosition, title: this.message.text,
      };
    },
    googleMapsKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_KEY;
    },
    sharedPosition() {
      let coords = this.message.media_uri.split(',');
      return {lat: parseFloat(coords[0]), lng: parseFloat(coords[1])};
    },
  },
}
</script>
